import { useEffect, useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import appointmentDetailsAtom from "../atoms/appointmentDetailsAtom";
import { url } from '../utils/config';
// import WorkOrder from "./WorkOrder";
import Map from "./Map";
// import CommentBox from "./CommentBox";
import axios from "axios";
import { toast } from "react-toastify";
import ViewWorkOrder from "./ViewWorkOrder";
import { useNavigate } from "react-router-dom";
import { btnOne } from "../utils/style";
import arrowBlack from '../assets/icons/arrow_black.png'
import navHeaderAtom from "../atoms/navHeaderAtom";
import Call from "./Call";
import VoiceCall from "./VoiceCall";
import Chat from "./Chat";
import EditAppointment from './EditAppointment';
import paymentDetailAtom from "../atoms/paymentDetailAtom";
import loaderStateAtom from "../atoms/loaderStateAtom";
import workOrderValueAtom from "../atoms/workOrderValueAtom";

function AppointmentDetails({ setShowAppointmentDetails, getAppointments, fetchAppointmentDetails }) {
    const [appointmentDetails, setAppointmentDetails] = useRecoilState(appointmentDetailsAtom);
    const [workOrder, setWorkOrder] = useRecoilState(workOrderValueAtom);
    const [showWorkOrderForm, setShowWorkOrderForm] = useState(false);
    const [showMap, setShowMap] = useState(false);
    const [modify, setModify] = useState(false);
    const [showCallOptions, setShowCallOptions] = useState(false)
    const [showCallModal, setShowCallModal] = useState(false)
    const [showChatScreen, setShowChatScreen] = useState(false)
    const [header, setHeader] = useRecoilState(navHeaderAtom)
    const [paymentDetail, setPaymentDetail] = useRecoilState(paymentDetailAtom)
    const [showLoader, setShowLoader] = useRecoilState(loaderStateAtom)
    const navigate = useNavigate()
    const [showEditForm, setShowEditForm] = useState(false);
    const [reloadAppointment, setReloadAppointment] = useState(false);

    useEffect(() => {
        if (showMap) {
            setHeader('Navigate')
        } else if (showWorkOrderForm) {
            setHeader('Work Estimate')
        } else {
            setHeader('Manage Appointment')
        }
    }, [showMap, showWorkOrderForm])


    useEffect(() => {
        if (reloadAppointment === true) {
            fetchAppointmentDetails(appointmentDetails.id)
        }
    }, [reloadAppointment])

    // async function completeService() {
    //     try {
    //         const { id, user_id } = appointmentDetails;
    //         const status = 'Closed'
    //         const reqUrl = url + '/booking_status';
    //         const token = window.localStorage.getItem('token');
    //         const headers = { authorization: `bearer ${token}` };
    //         const { data } = await axios.patch(reqUrl, { id, userId: user_id, status }, { headers });
    //         toast.success(data.message, { autoClose: 3000 });
    //         setShowAppointmentDetails(false)
    //         getAppointments()
    //     } catch (error) {
    //         console.log(error)
    //         toast.error(error?.response?.data?.message || error.message, { autoClose: 3000 })
    //     }
    // }

    function fetchAppointmentDetails(id) {
        if (!id) {
            return
        }
        setShowLoader(true)
        const reqUrl = url + '/appointment_details/' + id;
        const token = window.localStorage.getItem('token');
        const headers = { authorization: `bearer ${token}` };
        axios.get(reqUrl, { headers })
            .then(res => {
                setAppointmentDetails(res.data.data);
                let work_estimation = res.data.data.pilot_estimate;

                if (work_estimation) {
                    let serviceBundle = JSON.parse(work_estimation.bundleList);
                    let serviceList = JSON.parse(work_estimation.serviceList)
                    let materialList = JSON.parse(work_estimation.materialList)
                    let otherList = JSON.parse(work_estimation.otherList)
                    let id = work_estimation.id
                    setWorkOrder({
                        id,
                        serviceBundle,
                        serviceList,
                        materialList,
                        otherList,
                        estimatedExpirationDate: work_estimation.estimatedExpirationDate,
                        technicianCost: appointmentDetails.technicianHourlyCost,
                        estimatedCompletionDate: work_estimation.estimatedDate,
                        estimatedCompletionTime: work_estimation.estimatedTime,
                        uploadedImages: work_estimation.images || [],
                        estimateDeclineMessage: work_estimation.estimateDeclineMessage || '',
                    })
                }
                setShowLoader(false)
                setShowAppointmentDetails(true)
            })
            .catch(error => {
                setShowLoader(true)
                toast.error(error?.response?.data?.message || '', { autoClose: 3000 })
            })
    }

    const refreshHandler = () => {
        fetchAppointmentDetails(appointmentDetails.id)
    }

    // const formatDisplayDate = (dateString) => {
    //     if (!dateString) return 'Filter Date';

    //     try {
    //         // Convert yyyy-mm-dd to MM-DD-YYYY
    //         const [year, month, day] = dateString.split('-');
    //         return `${month}-${day}-${year}`;
    //     } catch (error) {
    //         console.error('Date formatting error:', error);
    //         return dateString;
    //     }
    // };


    const cancelApponitmentHandler = async (id) => {
        try {
            const token = window.localStorage.getItem('token');
            const response = await axios.delete(`${url}/booking/${id}`, {
                headers: { authorization: `bearer ${token}` }
            });
            if (response.status === 200) {
                toast.success("Appointment cancelled successfully", { autoClose: 3000 });
                getAppointments();
                setShowAppointmentDetails(false);
            } else {
                toast.error("Failed to cancel the appointment", { autoClose: 3000 });
            }
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.message || "An error occurred while cancelling the appointment", { autoClose: 3000 });
        }
    };

    // async function addComment(data) {
    //     try {
    //         const reqUrl = url + '/comment';
    //         const token = window.localStorage.getItem('token');
    //         const headers = { authorization: `bearer ${token}` };
    //         const res = await axios.post(reqUrl, { ...data, booking_id: appointmentDetails.id }, { headers });
    //         toast.success(res.data.message, { autoClose: 3000 })
    //     } catch (error) {
    //         toast.error(error?.response?.data?.message || error.message, { autoClose: 3000 })
    //     }
    // }

    function completePayment() {
        console.log(appointmentDetails);
        if (appointmentDetails.pilot_estimate?.pilot_bill !== null) {
            setPaymentDetail(appointmentDetails.pilot_estimate.pilot_bill)
            navigate('/payment_mode')
        }

    }

    function renderOption(estimate) {
        if (estimate === null) {
            return (
                <div className="flex flex-col items-center justify-center">
                    <div className="py-2">No Work Estimate Has Been Created Yet!</div>
                    {
                        appointmentDetails?.status === 'Assigned' &&
                        <div className="w-full">
                            <button className={btnOne} onClick={() => { setModify(false); setShowWorkOrderForm(true) }} >Create Work Estimate</button>
                        </div>
                    }
                </div>
            )
        } else {
            switch (estimate?.status) {
                case 'Pending':
                    return (
                        <>
                            <div className="text-black text-center">Approval Pending From User's End!</div>
                        </>
                    )
                    break;

                case 'Approved':
                    return (
                        <div className="flex flex-col items-center justify-center">
                            <div className="text-green-600 text-center">Work Estimate Has Been Approved!</div>
                            <div className="w-2/3">
                                <button className={btnOne} onClick={() => completePayment()} >Complete Payment</button>
                            </div>
                        </div>
                    )
                    break;

                case 'Rejected':
                    return (
                        <div className="flex flex-col items-center justify-center">
                            <div className="text-red-500">Work Estimate Has Been Rejected!</div>
                            <div className="border rounded-lg bg-gray-100 shadow-sm w-full px-4 py-2 m-2 break-words"><span className="font-semibold">Decline Reason:</span> {estimate.estimateDeclineMessage}</div>

                            <div className="mt-2">
                                <button className={btnOne} onClick={() => { setModify(true); setShowWorkOrderForm(true) }} >Modify Work Estimate</button>
                            </div>
                        </div>
                    )
                    break;

                // case 'Modified':
                //     return(
                //         <div className="text-green-500 text-center">Work Estimate Modified.Approval Pending From User's End!</div>
                //     )
                //     break;

                // case 'Closed':
                //     return(
                //         <>
                //         <div className="text-black text-center">The service request had been completed!</div>

                //         </>
                //     )
                //     break;

                default:
                    break;
            }
        }
    }

    const selectedChannel = {
        "sid": appointmentDetails.chatSid,
        "friendlyName": "service:" + appointmentDetails.id
    }

    const handleEditClick = () => {
        setShowEditForm(true);
    };

    return (
        !showWorkOrderForm ? (
            showEditForm ? (
                <EditAppointment
                    setShowEditForm={setShowEditForm}
                    getAppointments={getAppointments}
                />
            ) : (
                <div className="h-full bg-gray-50">
                    {/* Fixed Header */}
                    <div className="sticky top-0 bg-white border-b z-10 py-2">
                        <div className="flex items-center justify-start">
                            <div className="flex items-center">
                                <button
                                    className=" hover:bg-gray-100 rounded-full"
                                    onClick={() => { setShowAppointmentDetails(false); getAppointments(); }}
                                >
                                    <img src={arrowBlack} className="w-5 h-5" alt="back" />
                                </button>
                                <h2 className="ml-2 text-base font-medium">Appointment Details</h2>
                            </div>
                        </div>
                    </div>

                    {/* Scrollable Content */}
                    <div className="p-3 space-y-3">
                        {/* Quick Info Card */}
                        <div className="bg-white p-3 rounded-lg shadow-sm">
                            <div className="grid grid-cols-2 gap-3 mb-3">
                                <div>
                                    <div className="text-xs text-gray-500">Name</div>
                                    <div className="text-sm font-medium">{appointmentDetails?.pilot_user.name}</div>
                                </div>
                                <div>
                                    <div className="text-xs text-gray-500">Phone</div>
                                    <div className="text-sm font-medium">{appointmentDetails?.pilot_user.phone}</div>
                                </div>
                            </div>
                            <div>
                                <div className="text-xs text-gray-500">Email</div>
                                <div className="text-sm">{appointmentDetails?.pilot_user.email}</div>
                            </div>
                        </div>

                        {/* Schedule & Location */}
                        <div className="bg-white p-3 rounded-lg shadow-sm">
                            <div className="grid grid-cols-2 gap-3 mb-3">
                                <div>
                                    <div className="text-xs text-gray-500">Date</div>
                                    <div className="text-sm font-medium">{appointmentDetails.date}</div>
                                </div>
                                <div>
                                    <div className="text-xs text-gray-500">Time</div>
                                    <div className="text-sm font-medium">{appointmentDetails?.time}</div>
                                </div>
                            </div>
                            <div>
                                <div className="text-xs text-gray-500">Location</div>
                                <div className="text-sm">{appointmentDetails?.location}</div>
                            </div>
                        </div>

                        {/* Contact Options */}
                        {/* <div className="bg-white p-3 rounded-lg shadow-sm">
                            <div className="flex gap-3">
                                <button 
                                    onClick={() => setShowCallOptions(true)}
                                    className="flex-1 py-2 bg-customOne text-white rounded-md text-sm"
                                >
                                    Call
                                </button>
                                <button 
                                    onClick={() => setShowChatScreen(true)}
                                    className="flex-1 py-2 bg-customOne text-white rounded-md text-sm"
                                >
                                    Chat
                                </button>
                            </div>
                        </div> */}

                        {/* Vehicle Info */}
                        <div className="bg-white p-3 rounded-lg shadow-sm">
                            <div className="grid grid-cols-2 gap-3">
                                <div>
                                    <div className="text-xs text-gray-500">Make & Model</div>
                                    <div className="text-sm font-medium">
                                        {appointmentDetails?.make || 'N/A'} {appointmentDetails?.model || ''}
                                    </div>
                                </div>
                                <div>
                                    <div className="text-xs text-gray-500">Year</div>
                                    <div className="text-sm font-medium">
                                        {appointmentDetails?.year || 'N/A'}
                                    </div>
                                </div>
                                {/* <div>
                                    <div className="text-xs text-gray-500">Color</div>
                                    <div className="text-sm font-medium">
                                        {appointmentDetails?.color || 'N/A'}
                                    </div>
                                </div> */}
                                {/* <div>
                                    <div className="text-xs text-gray-500">Status</div>
                                    <div className={`text-sm font-medium ${
                                        appointmentDetails?.vehicleOperable ? 'text-green-600' : 'text-red-500'
                                    }`}>
                                        {appointmentDetails?.vehicleOperable ? 'Operable' : 'Not Operable'}
                                    </div>
                                </div> */}
                            </div>
                            {appointmentDetails?.issueDescription && (
                                <div className="mt-3 pt-3 border-t border-gray-100">
                                    <div className="text-xs text-gray-500">Issue Description</div>
                                    <div className="text-sm mt-1">
                                        {appointmentDetails.issueDescription}
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Service Details */}
                        <div className="bg-white p-3 rounded-lg shadow-sm">
                            <div className="space-y-2">
                                {/* <div>
                                    <div className="text-xs text-gray-500">Service Type</div>
                                    <div className="text-sm">{appointmentDetails?.serviceType || ''}</div>
                                </div> */}
                                {/* <div>
                                    <div className="text-xs text-gray-500">Problem</div>
                                    <div className="text-sm">{appointmentDetails?.problem || ''}</div>
                                </div> */}
                                {appointmentDetails?.problemDescription && (
                                    <div>
                                        <div className="text-xs text-gray-500">Description</div>
                                        <div className="text-sm">{appointmentDetails.problemDescription}</div>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Work Estimate */}
                        <div className="bg-white p-3 rounded-lg shadow-sm">
                            <div className="text-xs text-gray-500 mb-1 flex justify-between">
                                <p className="font-medium">Work Estimate</p>
                                <span className="flex items-center" onClick={refreshHandler}>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                    </svg>
                                </span>
                            </div>

                            <div className="text-sm">
                                {renderOption(appointmentDetails?.pilot_estimate)}
                            </div>
                        </div>


                        {/* Fixed Bottom Actions */}

                        {appointmentDetails.pilot_estimate === null &&
                            <div className="sticky bottom-0 bg-white p-3 border-t">
                                <div className="flex gap-3">
                                    <button
                                        onClick={handleEditClick}
                                        className="flex-1 py-2.5 bg-customOne text-white rounded-md text-sm"
                                    >
                                        Edit
                                    </button>
                                    <button className="flex-1 py-2.5 px-2 bg-red-500 text-white rounded-md text-sm" onClick={() => { cancelApponitmentHandler(appointmentDetails.id) }}>
                                        Cancel Appointment
                                    </button>
                                </div>
                                {/* {(appointmentDetails?.status === 'Assigned' || appointmentDetails?.status === 'On the way') && (
                                <button 
                                    onClick={() => setShowMap(true)}
                                    className="w-full mt-2 py-2.5 bg-green-600 text-white rounded-md text-sm"
                                >
                                    Navigate
                                </button>
                            )} */}



                            </div>
                        }
                    </div>

                    {/* Modals */}
                    {showMap && (
                        <Map
                            setShowModal={setShowMap}
                            userId={appointmentDetails.user_id}
                            id={appointmentDetails.id}
                            lat={appointmentDetails.latitude}
                            lng={appointmentDetails.longitude}
                        />
                    )}
                    {showCallOptions && (
                        <Call
                            setShowModal={setShowCallOptions}
                            setShowCallModal={setShowCallModal}
                            phone={appointmentDetails.userPhone}
                        />
                    )}
                    {showCallModal && (
                        <VoiceCall
                            outgoingCallerId={appointmentDetails.technicianPhone}
                            phone={appointmentDetails.userPhone}
                            setShowCallModal={setShowCallModal}
                        />
                    )}
                    {showChatScreen && (
                        <Chat
                            selectedChannel={selectedChannel}
                            setShowChatScreen={setShowChatScreen}
                            id={appointmentDetails.technician_id}
                            userId={appointmentDetails.user_id}
                        />
                    )}
                </div>
            )
        ) :
            <ViewWorkOrder setShowModal={setShowWorkOrderForm} setReloadAppointment={setReloadAppointment} />
    )
}

export default AppointmentDetails;
